import React, { Component } from 'react';
import uuid from 'uuid';
import {connect} from 'react-redux'
import {setRollUp} from '../actions/scActions'

class DropDownRollUp extends Component {

    render () {

        let rollUp = [{value:'1h',name:'1 hour'},
            {value:'2h',name:'2 hours'},
            {value:'4h',name:'4 hours'},
            {value:'6h',name:'6 hours'},
            {value:'12h',name:'12 hours'},
            {value:'24h',name:'24 hours'}
        ]
        let rollUpItems;

        rollUpItems = rollUp.map(rollUpItem => {
            return (
                <option key={uuid.v4()} value={rollUpItem.value}>{rollUpItem.name}</option>
            )
        });

        return (
            <div className="col-sm-offset-2 col-sm-4">
                <label>Rollup Measurement</label>
                <select className="form-control" value={this.props.sc.rollUp} onChange={(event) => this.props.changeRollUp(event.target.value)} >
                    {rollUpItems}
                </select>
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        sc: state.scReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeRollUp: (interval) => {
            dispatch(setRollUp(interval))
        }
    }
}

export default connect (mapStateToProps,mapDispatchToProps)(DropDownRollUp)


// WEBPACK FOOTER //
// ./src/containers/DropDownRollUp.js